module.exports = __webpack_public_path__ + "static/media/Ron_Geren.38623bbb.jpg";